import React, { useState } from "react";
import Button from "../../../form/Button";
import { classNames } from "../../../../helpers/classNames";
import { removeTag } from "../../../../helpers";

const ScholarshipTabContent = ({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="relative space-y-10">
      <div
        className={classNames(
          "text-base xls:text-lg font-Gotham xls:font-medium transition-all duration-200 overflow-hidden",
          isExpanded ? "max-h-[2000px]" : ""
        )}
        dangerouslySetInnerHTML={{ __html: data?.description }}
      />
      {removeTag(data?.description)?.length > 400 && (
        <div className="relative">
          <Button
            buttonLabel={isExpanded ? "Read Less" : "Read More"}
            buttonClasses={
              "!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"!text-base xl:!text-xl"}
            buttonFunction={() => setIsExpanded(!isExpanded)}
          />
        </div>
      )}
    </div>
  );
};

export default ScholarshipTabContent;
